import { AxiosError } from 'axios'
import { ENDPOINTS } from 'constants/endpoints'
import apiInstance from 'services/api/instance'

import { handleErrorMessage } from '../errors'

export const getAll = async (): Promise<AuditLogApiResponse[]> => {
  try {
    const getAllResponse = await apiInstance.get<AuditLogApiResponse[]>(
      ENDPOINTS.AUDITLOGS.GET_ALL,
    )

    return getAllResponse.data
  } catch (getAllError) {
    const axiosError = getAllError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const get = async (id: string): Promise<AuditLogApiResponse> => {
  try {
    const getResponse = await apiInstance.get<AuditLogApiResponse>(
      ENDPOINTS.AUDITLOGS.GET(id),
    )

    return getResponse.data
  } catch (getError) {
    const axiosError = getError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const create = async (
  auditlog: AuditLogsApiRequest,
): Promise<AuditLogApiResponse> => {
  try {
    const creationResponse = await apiInstance.post<AuditLogApiResponse>(
      ENDPOINTS.AUDITLOGS.CREATE,
      auditlog,
    )

    return creationResponse.data
  } catch (creationError) {
    const axiosError = creationError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const update = async ({
  id,
  auditlog,
}: {
  auditlog: AuditLogsApiRequest
  id: string
}): Promise<AuditLogApiResponse> => {
  try {
    const updateResponse = await apiInstance.put<AuditLogApiResponse>(
      ENDPOINTS.AUDITLOGS.UPDATE(id),
      auditlog,
    )

    return updateResponse.data
  } catch (updateError) {
    const axiosError = updateError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const remove = async (id: string) => {
  try {
    const deleteResponse = await apiInstance.delete(
      ENDPOINTS.AUDITLOGS.DELETE(id),
    )

    return deleteResponse.data
  } catch (deleteError) {
    const axiosError = deleteError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}
